module.exports = __webpack_public_path__ + "media/images/emblems/Pierrafortscha-coat_of_arms-e572f800ef804cfac9e1fe328cf350fc.svg";